import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { NgMaterialModule } from '../../shared/ng-material/ng-material.module';
import { TimeAgoPipe } from '../../shared/time-ago.pipe';
import { FilterModule } from '../filter/filter.module';
import { TablesRoutingModule } from './tables-routing.module';
import { TablesComponent } from './tables.component';

@NgModule({
  declarations: [TablesComponent, TimeAgoPipe],
  imports: [
    CommonModule,
    TablesRoutingModule,
    NgMaterialModule,
    FormsModule,
    FilterModule
  ]
})
export class TablesModule { }
